import React, { useEffect } from 'react'
import ListadoAvisos from './components/listado-avisos'
import { makeTitleListado } from '../../services/meta-tags-listado'

const ListadoAvisosBisPage = ({ location, match }) => {
  useEffect(() => {
    document.title = makeTitleListado({})
  }, [])

  return <ListadoAvisos parentRoute={{ location, match }} />
}

export default ListadoAvisosBisPage
